// The building plan in the 2D pane, for a glance link whose room was read
// from a drawing this pane cannot show yet (Apple RT06: the rooms come from
// DWGs, which have no rendered pages). The project overview's own PlanView
// on the room's level, the room filled - so the link still lands on a
// picture of where the room is instead of an empty sheet pane.
import React, { useEffect, useMemo, useState } from "react";
import { Empty, Spin } from "antd";
import { url, tokenRef } from "api";
import PlanView from "components/Coordination/Glance/PlanView";
import "components/Coordination/Glance/glance.css";

const auth = () => ({ Authorization: `Bearer ${localStorage.getItem(tokenRef)}` });

// Which room of the level: the glance's own id, else number, else name.
export function roomOnLevel(level, { roomId, room, roomName } = {}) {
  const rooms = (level && level.rooms) || [];
  const eq = (a, b) => String(a || "").trim().toUpperCase() === String(b || "").trim().toUpperCase();
  return (roomId && rooms.find((r) => String(r.id) === String(roomId)))
    || (room && rooms.find((r) => eq(r.number, room)))
    || (roomName && rooms.find((r) => eq(r.name, roomName)))
    || null;
}

export default function PlanFallback({ projectId, target }) {
  const [manifest, setManifest] = useState(null);
  const [error, setError] = useState("");
  useEffect(() => {
    let dead = false;
    setManifest(null); setError("");
    if (!projectId) return undefined;
    fetch(`${url}/projects/${projectId}/glance`, { headers: auth() })
      .then(async (r) => { const b = await r.json().catch(() => ({})); if (!r.ok) throw new Error(b.err || `HTTP ${r.status}`); return b; })
      .then((b) => { if (!dead) setManifest(b.manifest || null); })
      .catch((e) => { if (!dead) setError(e.message || "Could not load the building plan"); });
    return () => { dead = true; };
  }, [projectId]);

  const t = target || {};
  const levels = (manifest && manifest.levels) || [];
  const level = useMemo(() => levels.find((l) => String(l.id) === String(t.level))
    || levels.find((l) => String(l.name || "").toUpperCase() === String(t.levelName || "").toUpperCase())
    || null, [levels, t.level, t.levelName]);
  const room = roomOnLevel(level, t);

  if (error) return <div style={{ padding: 24 }}><Empty description={error} /></div>;
  if (!manifest) return <div style={{ padding: 24, textAlign: "center" }}><Spin /></div>;
  if (!level) return <div style={{ padding: 24 }}><Empty description="That level is not in the building data" /></div>;
  return (
    <div className="bl-glance ss-plan" style={{ height: "100%", overflow: "auto", padding: 8, margin: 0, fontSize: 14 }}>
      <style>{".ss-plan .g-room.is-selected{fill:#fe6919 !important;fill-opacity:.6 !important;stroke:#b8420a;stroke-width:2.5}"}</style>
      <div style={{ fontSize: 12, color: "#51606B", marginBottom: 4 }}>
        {room ? `${[room.name, room.number].filter(Boolean).join(" ")} on ${level.name || level.id}` : `${level.name || level.id}`}
        {" "}- building plan (the drawing it was read from can't be shown here yet)
      </div>
      <PlanView manifest={manifest} level={level} system={null} selectedRoomId={room ? room.id : null} onSelectRoom={() => {}} />
    </div>
  );
}
